import type { TaskPriority } from '@/types/task'

const PRIORITY_CONFIG: Record<TaskPriority, { label: string; className: string }> = {
  urgent: { label: 'Mendesak', className: 'bg-red-500/10 text-red-600 dark:text-red-400' },
  high: { label: 'Tinggi', className: 'bg-orange-500/10 text-orange-600 dark:text-orange-400' },
  medium: { label: 'Sedang', className: 'bg-blue-500/10 text-blue-600 dark:text-blue-400' },
  low: { label: 'Rendah', className: 'bg-secondary text-muted-foreground' },
}

interface PriorityBadgeProps {
  priority: TaskPriority
}

export function PriorityBadge({ priority }: PriorityBadgeProps) {
  const { label, className } = PRIORITY_CONFIG[priority] ?? PRIORITY_CONFIG.medium
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${className}`}>
      {label}
    </span>
  )
}
